export * from './faturamento-slice'
